import React from "react";

export default class Loading extends React.Component  {
    render() {
        return (
            <div className="account-pages my-5 pt-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-7">
                            <div className="mt-4 text-center">
                                <h1 className="mt-5 text-uppercase text-dark font-weight-bold mb-3" >Cargando...</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}